{
  "list": {
    "title": "智慧短語",
    "backToDashboard": "工作台",
    "newButton": "新增短語",
    "import": "匯入",
    "export": "匯出",
    "searchPlaceholder": "依關鍵字或展開文字搜尋...",
    "filterAllCategories": "全部類別",
    "header": "短語 ({{count}})",
    "loading": "正在載入短語...",
    "empty": "找不到短語。請建立您的第一個智慧短語。",
    "authoredBy": "作者:{{name}}",
    "tooltips": {
      "preview": "預覽",
      "edit": "編輯",
      "delete": "刪除"
    },
    "confirmDelete": "確認",
    "cancelDelete": "取消",
    "previewLabel": "預覽:",
    "closePreview": "關閉預覽",
    "toast": {
      "deleted": "短語已刪除",
      "importComingSoon": "匯入功能即將推出",
      "exportComingSoon": "匯出功能即將推出"
    }
  },
  "form": {
    "editTitle": "編輯智慧短語",
    "createTitle": "新增智慧短語",
    "fields": {
      "key": "關鍵字",
      "category": "類別",
      "expansionText": "展開文字"
    },
    "required": "*",
    "keyPlaceholder": ".normalexam",
    "keyHelper": "必須以 \".\" 開頭",
    "categoryUncategorized": "未分類",
    "expansionPlaceholder": "輸入將取代該捷徑的文字...",
    "cancel": "取消",
    "create": "建立短語",
    "update": "更新短語",
    "toast": {
      "created": "短語已建立",
      "updated": "短語已更新",
      "saveFailed": "儲存短語失敗",
      "keyMustStartWithDot": "關鍵字必須以 \".\" 開頭",
      "keyTooShort": "關鍵字至少需 2 個字元",
      "expansionRequired": "展開文字為必填"
    }
  },
  "category": {
    "general": "一般",
    "physicalExam": "理學檢查",
    "reviewOfSystems": "系統性回顧",
    "assessment": "評估",
    "plan": "計畫",
    "instructions": "醫囑說明",
    "medications": "藥物",
    "history": "病史"
  }
}
